import { render, staticRenderFns } from "./ConfigurarRecibos.vue?vue&type=template&id=7af56244"
import script from "./ConfigurarRecibos.vue?vue&type=script&lang=js"
export * from "./ConfigurarRecibos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports